import { sdkUtils, type Category } from "@koala/sdk";
import { useDispatch, useSelector } from "@/redux";
import menuActions from "@/redux/menu/actions";
import { fireGaEvent, gaActions, gaCats } from "@/utils/googleAnalytics";
import { type ExternalMenuLink } from "@/utils/menu";

const EXTERNAL_MENU_LINK_VALUE = "__external_menu_link__";

interface Props {
  categories: Category[];
  externalLink?: ExternalMenuLink | null;
}

export function DropDown({ categories, externalLink }: Props) {
  const dispatch = useDispatch();

  const navigationStatus = useSelector(
    (state) => state.app.menu.navigationStatus
  );

  /*
    Dropdown List
    - Accounting for category exclusions
    - Accounting for categories filtered by active tag
  */
  return (
    <select
      title="Choose a category"
      value={navigationStatus}
      onChange={(e) => {
        if (e.target.value === EXTERNAL_MENU_LINK_VALUE && externalLink) {
          fireGaEvent(gaCats.browse, gaActions.clickCategory, {
            label: externalLink.label,
          });
          window.open(externalLink.url, "_blank", "noopener,noreferrer");
          return;
        }

        const selectedCategory = categories.find(
          (category: Category) => String(category.id) === e.target.value
        );

        if (!selectedCategory) {
          return;
        }

        dispatch(
          menuActions.requestNavigationUpdate(String(selectedCategory.id))
        );
        fireGaEvent(gaCats.browse, gaActions.clickCategory, {
          label: `Mobile: ${selectedCategory?.name}`,
        });
      }}
    >
      {categories.map((category: Category, index: number) => (
        <option
          value={String(category.id)}
          key={`${sdkUtils.slugName(category)}-${index}`}
        >
          {category.name}
        </option>
      ))}
      {externalLink && (
        <option value={EXTERNAL_MENU_LINK_VALUE}>{externalLink.label}</option>
      )}
    </select>
  );
}
